import createTheme from '@mui/material/styles/createTheme';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { LumonusLogoDarkVertical, LumonusLogoOnly, LumonusLogoPNG } from 'shared-components/images';

const Logo = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <img src={LumonusLogoPNG} alt="Lumonus Logo" style={{ width: '137px', height: '44px' }} />
    </div>
  );
});

const DarkLogo = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <LumonusLogoDarkVertical />
    </div>
  );
});

const LogoOnly = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <LumonusLogoOnly />
    </div>
  );
});

const favicon =
  'data:image/png;base64,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';

const LinkBehavior = React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }>(
  (props, ref) => {
    const { href, ...other } = props;
    // Map href (Material UI) -> to (react-router)
    return <RouterLink ref={ref} to={href} {...other} />;
  },
);

const { palette } = createTheme({
  palette: {
    text: {
      primary: '#081e43',
      secondary: '#081e4399',
      disabled: '#081E4361',
    },
    primary: {
      main: '#081E43',
      dark: '#05152E',
      light: '#394B68',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#AAA1FD',
      dark: '#745DE5',
      light: '#CDC6FE',
      contrastText: '#081E43',
    },
    action: {
      active: '#AAA1FD',
      activatedOpacity: 1,
      hover: '#745DE50A',
      hoverOpacity: 0.04,
      selected: '#edeafb',
      selectedOpacity: 0.12,
      focus: '#745DE529',
      focusOpacity: 0.16,
      disabledBackground: '#0000001F',
      disabled: '#00000061',
      disabledOpacity: 0.38,
    },
    error: {
      main: '#FB6A76',
      dark: '#EC0031',
      light: '#FF969D',
      contrastText: '#081E43',
    },
    warning: {
      main: '#FFBD5B',
      dark: '#C55011',
      light: '#fdf5db',
      contrastText: '#081E43',
    },
    info: {
      main: '#65ABE8',
      dark: '#226BC0',
      light: '#EBE9FF',
      contrastText: '#081E43',
    },
    success: {
      main: '#3EC490',
      dark: '#007840',
      light: '#81D4B0',
      contrastText: '#081E43',
    },
    background: {
      default: '#FFFFFF',
      secondary: '#FAFAFF',
      paper: '#FFFFFF',
    },
    statusColors: {
      simulation: '#FBBC05',
      prescription: '#00a963',
      plan: '#00a3e1',
      cpot: '#e57c00',
      dxSubmitted: '#AAA1FD',
      draft: '#CFCDC9',
    },
    alert: {
      infoFill: '#F0F7FD',
    },
    statusContrastText: {
      simulation: '#FFFFFF',
      prescription: '#FFFFFF',
      plan: '#FFFFFF',
      cpot: '#FFFFFF',
      dxSubmitted: '#000000',
      draft: '#081e43',
    },
    tag: {
      main: '#c86ba8',
    },
  },
});

const theme = createTheme({
  custom: {
    logo: <Logo />,
    darkLogo: <DarkLogo />,
    logoOnly: <LogoOnly />,
    favicon,
    title: 'Lumonus AI',
    support: 'Lumonus support',
  },
  palette,
  typography: {
    allVariants: {
      color: palette.text.primary,
    },
    fontFamily: 'Poppins, Arial',
    h1: {
      fontSize: 96,
      fontWeight: 300,
    },
    h2: {
      fontSize: 60,
      fontWeight: 300,
    },
    h3: {
      fontSize: 48,
      fontWeight: 400,
    },
    h4: {
      fontSize: 34,
      fontWeight: 400,
    },
    h5: {
      fontSize: 24,
      fontWeight: 400,
    },
    h6: {
      fontSize: 20,
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: 14,
      fontWeight: 500,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
    },
    caption: {
      fontSize: 12,
      fontWeight: 400,
    },
    overline: {
      fontSize: 12,
      fontWeight: 400,
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
      styleOverrides: {
        root: {
          ':focus-visible': {
            outlineColor: palette.grey[300],
          },
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: 'black',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          color: palette.text.primary,
          textTransform: 'capitalize',
          fontWeight: 500,
          fontSize: '16px',
          borderRadius: '32px',
          '&.Mui-disabled': {
            color: palette.text.disabled,
          },
        },
        sizeLarge: {
          minWidth: '130px',
        },
        contained: {
          color: palette.primary.contrastText,
          backgroundColor: palette.primary.main,
        },
        outlined: {
          backgroundColor: palette.primary.contrastText,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        // darken error helper text
        root: {
          '&.Mui-error': {
            color: palette.error.dark,
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          ':hover': { color: 'white' },
          ':is(.MuiFab-colorInherit, .MuiFab-default):hover': {
            color: 'inherit',
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: palette.grey[300],
          color: palette.primary.dark,
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        // 'default' colours are error colours
        badge: {
          ':not([class*="MuiBadge-color"])': {
            backgroundColor: palette.error.main,
            color: palette.error.contrastText,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        // white text when hovered
        filled: {
          '&.MuiChip-clickable:hover': { color: 'white' },
          '&.MuiChip-colorDefault:hover': { color: 'unset' },
        },
        root: {
          // all avatar colour variants use text.primary besides primary
          '.MuiChip-avatar': {
            color: palette.text.primary,
          },
          '.MuiChip-avatarColorPrimary': {
            color: palette.primary.contrastText,
            backgroundColor: palette.primary.light,
          },
          // avatar background colours are color.light
          '.MuiChip-avatarColorSecondary': {
            backgroundColor: palette.grey[100],
          },
          '.MuiChip-avatarColorInfo': {
            backgroundColor: palette.info.light,
          },
          '.MuiChip-avatarColorWarning': {
            backgroundColor: palette.warning.light,
          },
          '.MuiChip-avatarColorError': {
            backgroundColor: palette.error.light,
          },
          '.MuiChip-avatarColorDefault': {
            // except default
            backgroundColor: palette.grey[300],
          },
          // arbitrary delete icon colour :(
          '.MuiChip-deleteIconColorDefault': {
            color: '#430098',
            opacity: 0.26,
          },
          // outlined variant uses dark version of respective colour
          '&.MuiChip-outlinedPrimary': {
            color: palette.primary.dark,
          },
          '&.MuiChip-outlinedSecondary': {
            color: palette.grey[600],
          },
          '&.MuiChip-outlinedInfo': {
            color: palette.info.dark,
          },
          '&.MuiChip-outlinedWarning': {
            color: palette.warning.dark,
          },
          '&.MuiChip-outlinedError': {
            color: palette.error.dark,
          },
          '&.MuiChip-outlinedDefault': {
            color: palette.primary.dark,
            borderColor: palette.action.active,
          },
          '&.MuiChip-colorDefault.MuiChip-clickable:hover': {
            backgroundColor: palette.secondary.light,
          },
          // Fix for line-height issue in chip labels that is caused by reset.css
          '.MuiChip-label': {
            lineHeight: '1.5',
            padding: '0 8px',
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          // left line and background for selected
          '.MuiListItemButton-root.Mui-selected': {
            borderLeft: `4px solid ${palette.primary.main}`,
          },
          // border radius for all top-level list items
          '.MuiListItem-root, .MuiListItemButton-root': {
            borderRadius: '4px',
          },
          '.MuiListItem-gutters, .MuiListItemButton-gutters': {
            paddingLeft: '12px',
            paddingRight: 0,
          },
          // get rid of jank overlay radius onClick
          '.Mui-selected>.MuiTouchRipple-root': {
            borderRadius: '0px 4px 4px 0px',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          // close icon of filled variant must be dark
          '&.MuiAlert-filled.MuiAlert-closeIcon': {
            color: palette.text.primary,
          },
        },
      },
    },
    // prefer secondary colour for progress
    MuiLinearProgress: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiCircularProgress: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        action: {
          color: palette.grey[100],
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          // text and border colours
          '.MuiPaginationItem-outlinedSecondary': {
            borderColor: '#43009839', // totally arbitrary opacity, love it
            '&.Mui-selected': {
              color: palette.grey[600],
            },
          },
        },
      },
    },
    MuiStepLabel: {
      // step label uses dark version of color
      styleOverrides: {
        label: {
          '&.Mui-error': {
            color: palette.error.dark,
          },
        },
      },
    },
    MuiStepIcon: {
      // step icons must have 24px min width
      styleOverrides: {
        root: {
          minWidth: '24px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        // tab text is darker when secondary
        textColorSecondary: {
          '&.Mui-selected': {
            color: palette.grey[600],
          },
          '&.Mui-selected svg': {
            color: palette.grey[300],
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        // tab indicator is darker when secondary
        indicator: ({ ownerState: { indicatorColor } }) => ({
          backgroundColor: indicatorColor === 'secondary' ? palette.grey[600] : palette.primary.main,
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        // default colour is primary
        root: {
          ':not([class*="MuiIconButton-color"])': {
            color: palette.primary.main,
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          '&.MuiAutocomplete-popper>.MuiAutocomplete-paper': {
            '.Mui-selected': {
              backgroundColor: palette.action.selected,
              ':hover': {
                backgroundColor: palette.action.hover,
              },
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            paddingLeft: '8px',
            input: {
              paddingLeft: 0,
            },
          },
        },
      },
    },
    // TODO: Look at this later. It is very difficult to set the MUI hover border color
    // (see https://github.com/mui/material-ui/blob/434c33fa9a3a4ad36047991fb9db15fd972f44fc/packages/mui-material/src/OutlinedInput/OutlinedInput.js#L44)
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: palette.grey[300],
          },
          '&.Mui-disabled': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.grey[300],
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          paddingLeft: '8px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingLeft: '0',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: 400,
          color: `${palette.text.primary} !important`,
          '&.MuiToggleButton-root.Mui-selected': {
            backgroundColor: palette.action.selected,
            color: palette.text.primary,
          },
          ':hover': {
            backgroundColor: palette.action.hover,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&[aria-selected="true"]': {
            backgroundColor: `${palette.action.focus} !important`,
          },
        },
      },
    },
  },
  zIndex: {
    fab: 7200,
  },
});

export type PaletteColour =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success'
  | 'text'
  | 'simulation'
  | 'tag';

export default theme;
